import { ExternalShareType } from "@amzn/ads-discovery-theme-service-typescript-client";

import { zustandStore } from "./zustand.helpers";

export type ShareContentState = {
    isModalOpen: boolean;
    isShareActive: boolean;
    originalFileFormat: string;
    externalShareType: ExternalShareType;
    externalShareInfo: ExternalShare;
    version: number;
    identifier: string;
};

export interface ExternalShare {
    externalShareExpiryDate: string;
    externalShareUrl: string;
    externalSharePasscode: string;
}

export const defaultExternalShareInfo: ExternalShare = {
    externalShareUrl: "Shareable link has not been generated",
    externalShareExpiryDate: "",
    externalSharePasscode: "-",
};

export const defaultContentVersion: number = 1;

export interface ShareContentActions {
    setIsModalOpen: (toggle: boolean) => void;
    setIsShareActive: (setIsShareActive: boolean) => void;
    setExternalShareType: (externalShareType: ExternalShareType) => void;
    setOriginalFileFormat: (fileType: string) => void;
    setExternalShareInfo: (externalShareInfo: ExternalShare) => void;
    setIdentifier: (identifier: string) => void;
    setVersion: (version: number) => void;
    reset: () => void;
}

export const initialState: ShareContentState = {
    isModalOpen: false,
    isShareActive: false,
    originalFileFormat: "",
    externalShareType: ExternalShareType.ORIGINAL,
    externalShareInfo: defaultExternalShareInfo,
    identifier: "",
    version: defaultContentVersion,
};

export const { store: shareContentStore } = zustandStore<
    ShareContentState,
    ShareContentActions
>("ShareContent", initialState, (set: any, get: any) => ({
    setIsModalOpen: (toggle: boolean) => set({ isModalOpen: toggle }),
    setIsShareActive: (isShareActive: boolean) => set({ isShareActive }),
    setExternalShareType: (externalShareType: ExternalShareType) =>
        set({ externalShareType }),
    setOriginalFileFormat: (originalFileFormat: string) =>
        set({ originalFileFormat }),
    setExternalShareInfo: (externalShareInfo: ExternalShare) => {
        const prev = get();
        return set(() => ({ ...prev, externalShareInfo }));
    },
    setIdentifier: (identifier: string) => set({ identifier }),
    setVersion: (version: number) => set({ version }),
    reset: () => set(initialState),
}));
